export enum EmailSentFields {
  id = "id",
  guestId = "guestId",
  eventId = "eventId",
  guestType = "guestType",
  mainGuest = "mainGuest",
  state = "state",
  acceptanceState = "acceptanceState",
  gender = "gender",
  title = "title",
  firstName = "firstName",
  lastName = "lastName",
  company = "company",
  jobTitle = "jobTitle",
  address = "address",
  address2 = "address2",
  zipCode = "zipCode",
  archived = "archived",
  city = "city",
  country = "country",
  email = "email",
  phone = "phone",
  mobile = "mobile",
  language = "language",
  username = "username",
  code = "code",
  checkedIn = "checkedIn",
  checkedInAt = "checkedInAt",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
  imageUrl = "imageUrl",
  numCompanions = "numCompanions",
  companions = "companions",
  emailOptIn = "emailOptIn",
  additionalFields = "additionalFields",
  emailSentId = "emailSentId",
  senderMailId = "senderMailId",
  senderMail = "senderMail",
  html = "html",
  attachments = "attachments",
  replyToMail = "replyToMail",
  ccMail = "ccMail",
  bccMail = "bccMail",
  mailSubject = "mailSubject",
  recipientMail = "recipientMail",
  templateName = "templateName",
  sentAt = "sentAt",
  emailStatus = "emailStatus",
  skipReason = "skipReason",
  sendName = "sendName",
  attachmentsDegraded = "attachmentsDegraded",
  attachmentDrops = "attachmentDrops",
  attachmentDegraded = "attachmentDegraded",
  softBounces = "softBounces",
  trackingMode = "trackingMode",
  trackingModeRequested = "trackingModeRequested",
  sendClass = "sendClass",
  notificationContactId = "notificationContactId",
  humanClickAt = "humanClickAt",
  machineClickAt = "machineClickAt",
  portalVisitedViaMailAt = "portalVisitedViaMailAt",
  websiteVisitedViaMailAt = "websiteVisitedViaMailAt",
  websiteLoginAt = "websiteLoginAt",
  portalVisitedAt = "portalVisitedAt",
}
